/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Shared_Existing_CopiesInputs */



/**
* | output |
* | --- |
* | "You have already copied this chat:" |
*
* @param {Chat_Shared_Existing_CopiesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_shared_existing_copies = /** @type {((inputs?: Chat_Shared_Existing_CopiesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Shared_Existing_CopiesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben diesen Chat bereits kopiert:")
	return /** @type {LocalizedString} */ ("You have already copied this chat:")
});